import { CompanyImportType, CompanyType, Source } from './company.model';

export interface CompanyImportRequest {
  mainCompanyType: CompanyType;
  mainCompanyImportType: CompanyImportType;
  text: string;
  mainCompany?: CompanyImport;
  relatedCompanies?: CompanyImport[];
}

export interface CompanyImportResponse {
  id: number;
  userId: number;
  jobType: JobType;
  status: JobStatus;
  parameters: CompanyImportRequest;
  output: CompanyImportOutput;
  errors: any[];
  warnings: any[];
  created: Date;
  updated: Date;
  duration?: number;
}

export enum JobType {
  COMPANY_IMPORT_TEXT = 'COMPANY_IMPORT_TEXT',
}

export enum JobStatus {
  WAITING = 'WAITING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  ERROR = 'ERROR',
}

export interface CompanyImportOutput {
  mainCompany: CompanyImport;
  relatedCompanies: CompanyImport[];
}

export interface CompanyImport {
  businessName: string;
  taxCodePrefix: string;
  taxCode: string;
  companyType: CompanyType;
  foundOnCribis: boolean;
  existing: boolean;
  existingByRole: boolean;
  existingRelationship?: boolean;
  transferType?: string;
  existingInvoiceTotalAmount?: number;
  trustRequired?: number;
  legalRepresentativeFirstName?: string;
  legalRepresentativeLastName?: string;
  legalRepresentativeEmail?: string;
  legalRepresentativePhone?: string;
  birthDate?: Date;
  legalRepresentativeBirthCity?: string;
  legalRepresentativeBirthState?: string;
  legalRepresentativeBirthCountry?: string;
  legalRepresentativeTaxCode?: string;
  legalRepresentativeAddress?: string;
  legalRepresentativeCity?: string;
  legalRepresentativeZip?: string;
  legalRepresentativeState?: string;
  legalRepresentativeCountry?: string;
  source?: Source;
  partnerId?: number;
  referrerId?: number;
  operationsUserId?: number;
  salesUserId?: number;
}

export interface CompanyImportUpdateDto {
  jobId: number;
  relatedCompanies: RelatedCompanies[];
}

export interface RelatedCompanies {
  businessName: string;
  taxCodePrefix: string;
  taxCode: string;
  transferType: string;
  existingInvoiceTotalAmount: number;
  trustRequired: number;
}

export interface CompanyValidateDto {
  jobId: number;
  relatedCompanies: UpdateCompanyContactDto[];
  mainCompany: UpdateCompanyContactDto;
}

export interface UpdateCompanyContactDto {
  legalRepresentativeFirstName: string;
  legalRepresentativeLastName: string;
  legalRepresentativeEmail: string;
  legalRepresentativePhone: string;
  birthDate: Date;
  legalRepresentativeBirthCity: string;
  legalRepresentativeBirthState: string;
  legalRepresentativeBirthCountry: string;
  legalRepresentativeTaxCode: string;
  legalRepresentativeAddress: string;
  legalRepresentativeCity: string;
  legalRepresentativeZip: string;
  legalRepresentativeState: string;
  legalRepresentativeCountry: string;
  source?: string;
  partnerId?: number;
  operationsUserId?: number;
  salesUserId?: number;
}
